import { render, staticRenderFns } from "./health-data-access.vue?vue&type=template&id=04c1c099&scoped=true&"
import script from "./health-data-access.vue?vue&type=script&lang=js&"
export * from "./health-data-access.vue?vue&type=script&lang=js&"
import style0 from "./health-data-access.vue?vue&type=style&index=0&id=04c1c099&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c1c099",
  null
  
)

component.options.__file = "health-data-access.vue"
export default component.exports